export default {
  depositsPage: {
    title: "Digital deposition",
    subtitle: "Public register of deposited works and intellectual activity results",
    applyFormCta: "Deposit your work",
    loadError: "Could not load the register. Please try again later.",
    loadMoreError: "Could not load more entries.",
    empty: "No entries yet",
    searchLabel: "Search the register",
    searchPlaceholder: "Search by title or certificate number\u2026",
    noTitle: "Untitled",
    statusUnknown: "Status {{status}}",
    rowOpen: "Open entry: {{title}}",
    open: "Open",
    table: {
      title: "Title",
      status: "Status",
      certificate: "Certificate number",
    },
    filters: {
      sortAria: "Sorting",
      sortCertifiedNewest: "Newest certification date first",
      sortCertifiedOldest: "Oldest certification date first",
      sortTitleAsc: "Title A–Z",
      sortTitleDesc: "Title Z–A",
      sortCertificateAsc: "Certificate number ascending",
      sortWorkDateNewest: "Newest work creation date first",
      serverFiltersAria: "Additional server-side filter parameters",
      workCategoryLabel: "Work category",
      industryDirectionLabel: "Industry direction",
      certifiedFrom: "Certified from",
      certifiedTo: "Certified to",
      optionAll: "All",
    },
  },
  depositDetail: {
    back: "Back",
    allDeposits: "Back to register",
    backToList: "All register entries",
    loadError: "Could not load the entry. Please try again later.",
    notFound: "Entry not found",
    status: "Status",
    certificateNumber: "Certificate number",
    certifiedAt: "Certification date",
    workCreationDate: "Work creation date",
    creationCountryId: "Country of creation",
    workCategory: "Work category",
    industryDirection: "Industry direction",
    authorsTitle: "Authors",
    rightsHoldersTitle: "Rights holders",
    emptyList: "No data",
    pseudonym: "pseudonym",
    sharePercent: "Share: {{value}}%",
  },
  depositPage: {
    kicker: "Copyright",
    title: "Work deposit",
    subtitle:
      "Official registration and copyright protection for your works in the collections of the Russian State Library.",
    step1Title: "Fill in the form",
    step1Desc: "Provide details about the work and author",
    step2Title: "Upload a file",
    step2Desc: "Attach an electronic copy of the work",
    step3Title: "Receive a certificate",
    step3Desc: "The deposit certificate will be emailed to you",
    formTitle: "Submit a deposit request",
    sentTitle: "Request submitted!",
    sentHint: "We will contact you within 3 business days.",
    authorName: "Author name *",
    email: "Email *",
    workTitle: "Work title *",
    workType: "Type of work *",
    workTypePlaceholder: "Select type",
    description: "Short description *",
    year: "Year created *",
    submit: "Submit request",
    whatIsTitle: "What is deposit?",
    whatIsText:
      "Deposit is the official transfer of a manuscript to the RSL for storage with a fixed creation date. It confirms authorship and protects your rights.",
    formatsTitle: "Accepted formats",
    helpTitle: "Need help?",
    helpText: "Our specialists can answer any questions about the deposit process.",
    workTypes: {
      article: "Scholarly article",
      monograph: "Monograph",
      fiction: "Literary work",
      dissertation: "Dissertation",
      textbook: "Textbook",
      other: "Other",
    },
    formats: {
      pdf: "PDF (preferred)",
      docx: "DOCX / DOC",
      odt: "ODT",
      rtf: "RTF",
    },
  },
  depositsPortal: {
    pageTitle: "Deposition cabinet",
    pageSubtitle: "Manage applications, track moderation, and receive certificates in one place.",
    kicker: "Cabinet",
    sidebarAria: "Deposit cabinet sections",
    sidebarTitle: "Deposition",
    sidebarSubtitle: "Applications and moderation",
    navAria: "Deposit cabinet navigation",
    navModerationSection: "Moderation",
    nav: {
      overview: "Overview",
      my: "My depositions",
      registry: "Public register",
      moderation: "Application review",
      newApplication: "Submit deposition",
    },
    overview: {
      title: "Cabinet overview",
      subtitle: "Summary of your applications and the moderation queue.",
      myHint: "Drafts, submitted applications, and issued certificates",
      moderationHint: "Review applications and issue certificates",
      noSections: "No overview sections are available for your account.",
      statsLoading: "Loading summary…",
      statsLoadError: "Could not load the summary. Please try again later.",
      totalMy: "Total: {{count}}",
      draftsCount: "Drafts: {{count}}",
      byStatusTitle: "By status",
      moderationByTabTitle: "Queue status filter",
      moderationTotalRowLabel: "Total",
      goToSection: "Go to section",
      retry: "Retry request",
    },
    intro: {
      title: "Secure authorship of your project",
      subtitle: "Deposition is a simple way to prove you created the work first.",
      legalHint:
        "Deposition records your authorship of a creative result at a specific point in time. It is not a state registration of copyright but establishes priority and serves as evidence of authorship.",
      howTitle: "How it works",
      step1Title: "Upload the project",
      step1Desc: "Pick a ready project from your portfolio or upload a file",
      step2Title: "Fill in the details",
      step2Desc: "Provide author, title, type, and creation date",
      step3Title: "Receive the certificate",
      step3Desc: "After moderation you can download the deposition certificate",
      startCta: "Start deposition",
      continueDraftCta: "Continue draft",
      backToList: "Back to my depositions",
      startError: "Could not create the application.",
    },
    my: {
      title: "My depositions",
      subtitle: "Drafts, submitted applications and issued certificates.",
      sectionSubtitle: "Search, status and sorting.",
      loadError: "Could not load the list. Please try again later.",
      empty: "You have no applications yet.",
      emptySearch: "No applications found with this title.",
      emptyCta: "Submit a deposition application",
      continue: "Continue",
      deleteDraft: "Delete draft",
      confirmDeleteDraftTitle: "Delete this draft?",
      confirmDeleteDraftMessage: "This cannot be undone.",
      deleteError: "Could not delete the draft.",
      openInRegistry: "In register",
      updated: "Updated",
      totalCount: "Total records: {{count}}",
      open: "Open",
      downloadCert: "Certificate",
      downloadCertLinkAria: "Open certificate for application «{{title}}»",
      tabsAria: "Status filter",
      tabs: {
        all: "All",
        draft: "Drafts",
        moderation: "Pending moderation",
        confirmed: "Confirmed",
        rejected: "Rejected",
        revision: "Needs revision",
      },
      filters: {
        search: "Search by title",
        searchPlaceholder: "Work title…",
        statusAria: "Application status",
        sortAria: "Sort list",
        sortNewest: "Newest first",
        sortOldest: "Oldest first",
        sortTitle: "By title (A—Z)",
      },
      activeDraft: {
        title: "You have an active draft",
        noTitle: "Untitled draft",
        continue: "Continue",
        discard: "Delete",
      },
      revision: {
        banner_one: "You have {{count}} application in revision",
        banner_other: "You have {{count}} applications in revision",
        showAll: "Show all",
        continue: "Continue revision",
        continueAria: "Continue revising application «{{title}}»",
      },
    },
    myDetail: {
      back: "Back to my depositions",
      loadError: "Could not load the record. Please try again later.",
      certDownloadError: "Could not download the certificate.",
      originalDownloadError: "Could not download the original file.",
      resumeError: "Could not open the draft for revision.",
      downloadCert: "Download certificate",
      downloadOriginal: "Download original",
      submittedAt: "Submitted at",
      certifiedAt: "Certified at",
      sections: {
        main: "Main information",
        file: "Work file",
      },
      fileName: "File name",
      fileSize: "Size",
      fileType: "Type",
      sha256: "SHA-256",
      revisionTitle: "Application returned for revision",
      revisionEmpty: "The moderator did not leave a comment.",
      resumeRevision: "Continue revision",
      draftEditTitle: "Application is a draft",
      draftEditDescription:
        "Edit the details and submit the application for moderation again — for example, after withdrawing it from review.",
      rejectedTitle: "Application rejected",
      withdrawFromModeration: "Withdraw from moderation",
      withdrawFromModerationConfirm:
        "Withdraw this application from moderation? You can submit it again after editing the draft.",
      withdrawFromModerationError: "Could not withdraw the application from moderation.",
      withdrawFromModerationAria: "Withdraw application «{{title}}» from moderation",
      deleteApplicationAria: "Delete application «{{title}}»",
    },
    moderation: {
      title: "Deposition moderation",
      subtitle: "Applications awaiting a decision. Filters and search for the queue.",
      loadError: "Could not load the queue.",
      forbidden403:
        "Access denied: this application is outside your industry moderation scope, or your permissions are insufficient. Contact an administrator if you believe this is a mistake.",
      empty: "No applications match the selected filters.",
      totalCount: "Total: {{count}}",
      approve: "Approve",
      reject: "Reject",
      approveError: "Could not approve the application.",
      rejectError: "Could not reject the application.",
      rejectTitle: "Rejection reason",
      rejectReason: "Message to the applicant",
      cancel: "Cancel",
      rejectConfirm: "Reject",
      openDetail: "Open",
      openDetailAria: "Open application «{{title}}» for moderation",
      approveAria: "Approve application «{{title}}»",
      rejectAria: "Reject application «{{title}}»",
      primaryAuthor: "Author",
      listIndustryDirection: "Industry direction:",
      listWorkCategory: "Work category:",
      tabs: {
        all: "All",
        pending: "In queue",
        confirmed: "Confirmed",
        revision: "Needs revision",
        rejected: "Rejected",
      },
      filters: {
        title: "Title",
        titlePlaceholder: "Work title…",
        certificateOrId: "Number / ID",
        certificateOrIdPlaceholder: "Certificate or UUID…",
        author: "Author name",
        authorPlaceholder: "John Smith…",
        rightsHolder: "Rights holder",
        rightsHolderPlaceholder: "Name, organization, contact, INN, OGRN…",
        from: "Submitted from",
        to: "Submitted to",
        status: "Queue status",
        datePlaceholder: "Select date",
        calendarFromAria: "Calendar: submitted from",
        calendarToAria: "Calendar: submitted to",
        statusFilterAria: "Filter queue by status",
      },
    },
    moderationDetail: {
      back: "Back to moderation queue",
      loadError: "Could not load the application.",
      revisionError: "Could not send the application for revision.",
      downloadOriginal: "Download original",
      sendForRevision: "Send for revision",
      revisionTitle: "Send back for revision",
      revisionComment: "Message to the applicant",
      revisionSend: "Send",
      confirmApprove: "Approve the application and issue the certificate?",
      sections: {
        main: "Main information",
      },
      creationCity: "Creation city",
      applicant: "Applicant",
      applicantId: "User ID",
      primaryAuthor: "Primary author",
      consentPersonalData: "Consent: personal data processing",
      consentDepositRules: "Consent: deposition rules",
      consentUserTerms: "Consent: user terms",
      legalDocumentsVersion: "Legal documents version",
      applicantHint: "Full applicant profile is unavailable: showing data from the application.",
      statusHistory: "Status history",
      moderationActions: "Moderation actions",
      contactPerson: "Contact person",
      linkedUserId: "Linked user",
      authorRole: {
        author: "Author",
        coAuthor: "Co-author",
      },
    },
    wizard: {
      title: "Deposition application",
      subtitle: "Complete the steps and submit for review.",
      preparing: "Creating draft…",
      createError: "Could not create the application.",
      loadError: "Could not load the application.",
      saveError: "Could not save.",
      submitError: "Could not submit the application.",
      uploadError: "Could not upload the file.",
      notDraftHint: "This application was already submitted or cannot be edited.",
      backToList: "Back to my depositions",
      stepsAria: "Application steps",
      stepLabel: {
        1: "File",
        2: "Authors & rights holders",
        3: "Work",
      },
      stepHeading: {
        1: "Upload the work file",
        2: "Work details",
        3: "Authors",
        4: "Rights holders",
      },
      stepFile: {
        title: "Work file",
        hint: "Upload the finished file. Its sha256 hash is recorded as proof of integrity.",
        maxSizeWarning: "Maximum file size is 150 MB.",
        fileTooLarge: "This file is larger than 150 MB. Please choose a smaller file.",
        dropZoneTitle: "Click to choose a file",
        dropZoneSubtitle:
          "Accepted: PDF; JPEG, PNG, and JFIF images; MP4, MOV, AVI, MKV, and WebM video; MP3, WAV, OGG, FLAC, AAC, M4A, M4B, M4P, and M4V audio.",
        uploading: "Uploading…",
        unnamedFile: "File",
        replace: "Replace file",
        clear: "Remove file",
      },
      consents: {
        title: "I confirm",
        personalData: "Consent to personal data processing.",
        depositRules: "Deposition rules and procedures.",
        userTerms: "User agreement and privacy policy.",
        link: "Open document",
      },
      fields: {
        title: "Work title",
        description: "Description",
        workCategory: "Work category",
        industryDirection: "Industry direction",
        workCreationDate: "Work creation date",
        country: "Country of creation",
        authorName: "Author full name",
        authorLastName: "Last name",
        authorFirstName: "First name",
        authorPatronymic: "Patronymic",
        authorRole: "Role",
        pseudonym: "Pseudonym",
        authorCountry: "Author country",
        holderKind: "Rights holder type",
        holderName: "Full name",
        orgName: "Organization name",
        sharePercent: "Share, %",
        holderInn: "INN (tax ID)",
        holderOgrn: "OGRN (reg. number)",
        holderContactPerson: "Contact person",
        holderCountry: "Rights holder country",
      },
      placeholders: {
        select: "Select…",
        country: "Country…",
        date: "Select date…",
      },
      hints: {
        shareTotal:
          "The total share of all rights holders is 100%. When you change one holder’s share, the others are adjusted automatically (proportionally to their previous shares).",
        shareClamped: "Share cannot exceed 100%.",
        titleMaxLength: "255 characters is the maximum title length.",
      },
      addAuthor: "Add author",
      addRightsHolder: "Add rights holder",
      removeRow: "Remove",
      back: "Back",
      next: "Next",
      exit: "Back to list",
      submit: "Submit for moderation",
      footerTooltips: {
        exit:
          "Close the wizard and return to your applications list. Progress is kept in the draft when you move between steps.",
        back: "Go back to the previous step without submitting the application.",
        next: "Validate this step, save, and continue to the next one.",
        nextBusy: "Saving step, please wait…",
        submit: "Submit the completed application for moderation review.",
        submitBusy: "Submitting application, please wait…",
      },
      validation: {
        file: "Upload the work file.",
        title: "Enter the work title.",
        workCategory: "Select a work category.",
        industryDirection: "Select an industry direction.",
        workCreationDate: "Enter the work creation date.",
        creationCountry: "Select the country of creation.",
        author: "For each author, enter last name and first name.",
        rightsHolder:
          "For each rights holder, fill required fields: individual — country and full name; organization — country, name, INN, OGRN, contact person.",
        consents: "Confirm all three consents.",
      },
    },
  },
  depositDrafts: {
    title: "My application drafts",
    subtitle: "Drafts are saved while you fill out an application. Continue editing or remove ones you do not need.",
    loginPrompt: "Sign in to view and create deposition application drafts.",
    loginCta: "Sign in",
    newDraft: "New draft",
    creating: "Creating…",
    loadError: "Could not load drafts. Please try again later.",
    createError: "Could not create a draft. Please try again later.",
    detailLoadError: "Could not load the draft.",
    empty: "No drafts yet.",
    totalCount: "Total drafts: {{count}}",
    tableAria: "List of deposition application drafts",
    colTitle: "Title",
    colStep: "Step",
    colCreated: "Created",
    colFlags: "Data",
    colActions: "Actions",
    flagPortfolio: "Portfolio",
    flagFile: "File",
    openDraft: "Open draft: {{title}}",
    continueDraft: "Continue application: {{title}}",
    deleteDraft: "Delete draft: {{title}}",
    modalTitle: "Draft",
    modalClose: "Close",
    modalStep: "Current step",
    modalWorkTitle: "Work title",
    modalDescription: "Description",
    modalWorkDate: "Work creation date",
    modalId: "Identifier",
    cabinetDraftHint: "Application in preparation or withdrawn from moderation — continue in the wizard.",
    cabinetNoDeleteHint:
      "The Delete button only removes drafts from the list above. Applications from your cabinet (including withdrawn from moderation) cannot be removed this way — the API does not expose deleting a deposit record.",
    continueCabinetRecord: "Continue in wizard",
    openCabinetRecord: "Application details",
  },
}
